import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';
import { PensionBase } from '../../Models/Models/QuoteAndApplyBase/PensionBase';

declare var IS_RUNNING_IN_APP_POOL;

export class PensionSubAccountAmendmentInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(hierarchyId: string, model: PensionBase, customerId: string, claccountId: string): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/PensionSubAccountAmendmentInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, model: model, customerId: customerId, claccountId: claccountId }

    return AjaxWrapper.put<ValidationStatus, any>(url, data);
  }
}

